export default __webpack_public_path__ + "static/media/21.04f52b69.jpg";